import { MoonIcon } from "@chakra-ui/icons";
import { Flex } from "@chakra-ui/react";

export function OvernightBadge() {
  return (
    <Flex
      align="center"
      bg="gray.100"
      borderRadius="md"
      fontSize="xs"
      fontWeight="bold"
      gap={2}
      justify="center"
      py={1}
      w="full"
    >
      <MoonIcon />
      Overnight
    </Flex>
  );
}
